import React, { useContext, useState } from 'react';
import "./Navigation.css";
import img from "./user.png";
import Nav from '../Nav/Nav'
import { BiGridAlt } from "react-icons/bi";
import {TbFileUpload} from 'react-icons/tb'
import { GoPeople } from "react-icons/go";
import { FiSettings } from "react-icons/fi";
import { AiOutlineCalendar } from "react-icons/ai";
import { IoStatsChartOutline } from "react-icons/io5";
import { BiFile } from "react-icons/bi";
import { BiMessageRounded } from "react-icons/bi";
import { CiCircleInfo } from "react-icons/ci";
import { BiBookAlt } from "react-icons/bi";
import {FiChevronLeft,FiMessageSquare} from 'react-icons/fi'
import {AiOutlineUsergroupAdd,AiOutlineDollarCircle,AiOutlineUserSwitch} from 'react-icons/ai'
import {MdOutlineNotificationsActive,MdSwapHoriz} from 'react-icons/md'
import {BiMessageAltAdd,BiDotsHorizontalRounded} from 'react-icons/bi'
import { Theme } from '../../Theme';

const Navigation=()=> {
  const [nav,setnav]=useState(false);

  const {DarkTheme,setDarkTheme}=useContext(Theme);
  function changeTheme(){
    setDarkTheme(!DarkTheme);
  }

  return (
    <div className={`navigation ${nav && "active"} ${DarkTheme && "dark"}`}>
      <div className={`menu ${nav && "active"}`} onClick={()=>{
        setnav((prevState)=>!prevState)
      }}>
        <FiChevronLeft className='menu-icon'/>
      </div>

      <header>
        <div className="profile">
            <img src={img} alt="user img" className="profile-img" />
        </div>
      </header>
      <Nav title="Dashboard" Icon={BiGridAlt}></Nav>
      <Nav title="Client Management" Icon={GoPeople}></Nav>
      <Nav title="Calender" Icon={ AiOutlineCalendar }></Nav>
      <Nav title="KPI Tracker" Icon={AiOutlineUsergroupAdd}></Nav>
      <Nav title="Finance" Icon={IoStatsChartOutline }></Nav>
      <Nav title="Education" Icon={BiBookAlt}></Nav>
      <Nav title="Community Chat" Icon={BiMessageRounded}></Nav>
      <Nav title="Billing" Icon={BiFile}></Nav>
      <Nav title="Help and Support" Icon={CiCircleInfo}></Nav>
      <Nav title="Setting" Icon={FiSettings}></Nav>
    </div>
  )
}

export default Navigation;
